import React, { useEffect, useState } from 'react';
import axiosInstance from './utils/axiosinstance';
import DropdownMenu from './shared/DropdownMenu';

const ImageDropdown = ({ selectedIndex, onSelect }) => {
    const [images, setImages] = useState([]);

    const fetchImages = async () => {
        const response = await axiosInstance.get('/api/fetch_images/');
        setImages(response.data.images);
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const handleImageSelect = (image) => {
        console.log('Selected image:', image);
        onSelect(image);
    };

    return (
        <DropdownMenu
            initialIndex={selectedIndex}
            onSelect={handleImageSelect}
            items={images}
            selectText="Select an image"
        />
    );
};

export default ImageDropdown;
